/* tslint:disable */
/* eslint-disable */
/* @relayHash c228a15fa55045bd9a6a18849bbfccdc */

import { ConcreteRequest } from "relay-runtime";
export type HomepageHoldoutGroup = "consumer" | "control" | "trade" | "%future added value";
export type checkHoldoutGroupQueryVariables = {
    userId: string;
};
export type checkHoldoutGroupQueryResponse = {
    readonly viewer: {
        readonly homepageUserGroup: HomepageHoldoutGroup | null;
    };
};
export type checkHoldoutGroupQuery = {
    readonly response: checkHoldoutGroupQueryResponse;
    readonly variables: checkHoldoutGroupQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "homepageUserGroup",
  "args": [
    {
      "kind": "Variable",
      "name": "userId",
      "variableName": "userId"
    }
  ],
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "checkHoldoutGroupQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "checkHoldoutGroupQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "checkHoldoutGroupQuery",
    "id": "ferrum/292.0.0-2020-11-18T17:30:45.474Z/checkHoldoutGroupQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '57d231fc084783b14d344ca83fa0023f';
export default node;
